import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _assertThisInitialized from "@babel/runtime/helpers/assertThisInitialized";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import * as React from 'react';
import * as styles from './styles.css';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var AnimatedContent = /*#__PURE__*/function (_React$Component) {
  _inherits(AnimatedContent, _React$Component);
  var _super = _createSuper(AnimatedContent);
  function AnimatedContent() {
    var _this;
    _classCallCheck(this, AnimatedContent);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty(_assertThisInitialized(_this), "state", {
      blockIndex: 1
    });
    _defineProperty(_assertThisInitialized(_this), "intervalId", void 0);
    return _this;
  }
  _createClass(AnimatedContent, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;
      this.intervalId = setInterval(function () {
        _this2.setState(function (_ref) {
          var blockIndex = _ref.blockIndex;
          return {
            blockIndex: blockIndex === 3 ? 1 : blockIndex + 1
          };
        });
      }, 8000);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearInterval(this.intervalId);
    }
  }, {
    key: "render",
    value: function render() {
      switch (this.state.blockIndex) {
        case 1:
          return /*#__PURE__*/_jsxs("div", {
            className: styles['dots'],
            children: [/*#__PURE__*/_jsx("div", {
              className: styles['dot']
            }), /*#__PURE__*/_jsx("div", {
              className: styles['dot']
            }), /*#__PURE__*/_jsx("div", {
              className: styles['dot']
            })]
          });
        case 2:
          return /*#__PURE__*/_jsx("div", {
            className: styles['circle-text']
          });
        case 3:
          return /*#__PURE__*/_jsx("div", {
            className: styles['smile']
          });
        /* istanbul ignore next */
        default:
          return null;
      }
    }
  }]);
  return AnimatedContent;
}(React.Component);